module.exports = __webpack_public_path__ + "static/media/india.ca5c321c.svg";